import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Card, Col, Container, Row } from 'reactstrap';
import data from '../data/inspiration-block.json';
import { getImageUrl } from "../services/image";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InspirationBlock = function InspirationBlock(props) {
  return /*#__PURE__*/_jsx("section", {
    className: "py-3 ".concat(props.greyBackground ? 'bg-gray-100' : ''),
    children: /*#__PURE__*/_jsx(Container, {
      fluid: true,
      children: /*#__PURE__*/_jsx(Row, {
        className: "",
        children: /*#__PURE__*/_jsxs(Col, {
          xl: "10",
          lg: "10",
          className: "mx-auto",
          children: [/*#__PURE__*/_jsxs(Row, {
            className: "mb-5",
            children: [/*#__PURE__*/_jsxs(Col, {
              md: "8",
              children: [/*#__PURE__*/_jsx("p", {
                className: "subtitle text-primary",
                children: props.subTitle
              }), /*#__PURE__*/_jsx("h2", {
                children: props.title
              })]
            }), /*#__PURE__*/_jsx(Col, {
              md: "4",
              className: "d-md-flex align-items-center justify-content-end",
              children: data.buttonLink && /*#__PURE__*/_jsx(Link, {
                href: data.buttonLink,
                children: /*#__PURE__*/_jsxs("a", {
                  className: "text-muted text-sm",
                  children: [data.button, /*#__PURE__*/_jsx("i", {
                    className: "fas fa-angle-double-right ml-2"
                  })]
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Row, {
            children: data.cities && data.cities.map(function (city, index) {
              return /*#__PURE__*/_jsx(Col, {
                lg: city.width,
                className: "d-flex align-items-lg-stretch mb-4 block-item",
                children: /*#__PURE__*/_jsxs(Card, {
                  className: "shadow-lg border-0 w-100 border-0 hover-animate",
                  children: [/*#__PURE__*/_jsx(Link, {
                    href: city.link,
                    children: /*#__PURE__*/_jsx("a", {
                      className: "tile-link text-shadow text-uppercase",
                      children: city.title
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: "d-flex align-items-center h-100 text-white justify-content-center py-6 py-lg-7 inspirational-item",
                    children: /*#__PURE__*/_jsx(Image, {
                      placeholder: "blur",
                      blurDataURL: getImageUrl('image-loader2.jpeg'),
                      src: getImageUrl(city.img),
                      layout: "fill",
                      objectFit: "cover",
                      className: "card"
                    })
                  })]
                })
              }, index);
            })
          })]
        })
      })
    })
  });
};

export default InspirationBlock;